import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { PRODUCTS } from '../components/InviteTray/productCatalog';

/** The product catalog with its tray title and description formatted for the current locale. */
export function useLocalizedProducts() {
  const { formatMessage } = useIntl();

  return useMemo(
    () =>
      PRODUCTS.map(({ trayTitleMessage, descriptionMessage, ...product }) => ({
        ...product,
        title: formatMessage(trayTitleMessage),
        description: formatMessage(descriptionMessage),
        hideIcon: Boolean(product.hideIconInTray),
      })),
    [formatMessage],
  );
}
